import type { ContractMode } from 'contexts/contract/interface'
import * as yup from 'yup'
import { createChassiSchema } from '../../StepsForm/Utils/chassiSchema'

export const schema = (type: ContractMode = 'CREATE') =>
    yup.object({
        uf: yup.string().required(),
        chassi: createChassiSchema(type),
        temp: yup.boolean()
    })
